import React from 'react';
//import {useMutation, useNotify, Button } from 'react-admin';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ErrorBoundary from '../ErrorBoundary';


const styles = {
    icon: { paddingRight: '0.5em' },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
};

const LinkToCreate = ({ classes, ...props}) => {
    return 
    <ErrorBoundary>  
       <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/spe/create',
            ssn: props.ssn,
            deferral_code: props.deferral_code,
            deferral_date: props.deferral_date,
            deferral_exp_date: props.deferral_exp_date,
            deferral_comments: props.deferral_comments
        }}
        className={classes.link}
        {...props}
       
    >
        <AddCircleIcon className={classes.icon} />Create
    </Button>
</ErrorBoundary>  
};

export default withStyles(styles)(LinkToCreate);